import { useEffect } from 'react'
import { useAppDispatch, useAppSelector } from 'hooks/reduxHooks'
import fetchMerchandiseSearchTypeahead from 'actions/merchandise/fetchMerchandiseSearchTypeahead'

type ReturnType = [
  App.MerchandiseSearchTypeahead,
  boolean,
  any,
]

const EmptyResults: App.MerchandiseSearchTypeahead = {
  categories: [],
  brands: [],
  products: [],
}

function useMerchandiseSearchTypeahead(query: string): ReturnType {
  const dispatch = useAppDispatch()
  const results = useAppSelector(state => state.merchandise.merchandiseSearchTypeahead[query])

  useEffect(() => {
    dispatch(fetchMerchandiseSearchTypeahead(query))
  }, [dispatch, query])

  return [
    results?.results ?? EmptyResults,
    results?.fetching ?? false,
    results?.error,
  ]
}

export default useMerchandiseSearchTypeahead
